
import { applicantStore } from '@/store'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ContactInfo extends Vue {
    get address (): string {
        return applicantStore.addressWithPostalCode
    }

    get phone (): string {
        return applicantStore.applicationContact.phoneNumber || ''
    }

    get eMail (): string {
        return applicantStore.applicationContact.email || ''
    }

    get addressNotes (): string | null {
        return applicantStore.applicationContact.address.notes
    }
}
